/**
 * CARTAL — Google Analytics 4 page-view tracker for React Router SPAs
 * ────────────────────────────────────────────────────────────────────
 * The gtag <script> in public/index.html is configured with
 * `send_page_view: false`, which prevents the initial + navigation-based
 * duplicate events that plague SPAs. We instead call `page_view` here
 * once per React Router location change (including the first render).
 *
 * Usage — mount `<Ga4PageViews />` ONCE at the top of the app tree,
 * inside <BrowserRouter>. Nothing else required.
 *
 * GA4 property: G-1M7BTRW69F  (installed 2026-02, iter111).
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const GA_MEASUREMENT_ID = "G-1M7BTRW69F";

export function trackPageView(path, title) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: title || document.title,
    page_location: window.location.href,
    page_path: path || (window.location.pathname + window.location.search),
    send_to: GA_MEASUREMENT_ID,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, { ...params, send_to: GA_MEASUREMENT_ID });
}

export default function Ga4PageViews() {
  const loc = useLocation();
  useEffect(() => {
    // Small delay so document.title has settled after a route change
    // (many pages update it in a top-level useEffect).
    const t = setTimeout(() => {
      trackPageView(loc.pathname + loc.search, document.title);
    }, 50);
    return () => clearTimeout(t);
  }, [loc.pathname, loc.search]);
  return null;
}
